<template>
    <div class="flex justify-between items-center n-color-text hover:bg-grey-100 py-3 px-5 rounded group">
        <slot />
    </div>
</template>
